export default defineAppConfig({
  ui: {
    colors: {
      primary: 'golden-grass',
      neutral: 'marshland'
    },
    pageSection: {
      slots: {
        container: 'py-12 sm:py-16 lg:py-20'
      }
    },
    navigationMenu: {
      slots: {
        linkLabel: 'text-marshland-200 hover:text-golden-grass focus-visible:text-marshland-200',
      }
    },
  }
})